module.exports = __webpack_public_path__ + "6d6bf293d3302434abe86641117d96df.jpg";